<main>
  @if (!isLoading) {
    <div class="sign-in-page">
      <section class="left-side" [@fadeInLeft]>
        <div class="logo">
          <img
            src="assets/imgs/psicogenius_with_border.png"
            alt="logo"
            class="img"
          />
        </div>
        <div class="content">
          <h1 class="title" [@fadeInUp]="'title'">Benvenuto in PSICOGENIUS</h1>
          <p class="sub-title" [@fadeInUp]="'subtitle'">
            Il primo software AI per Psicologi, Psicoterapeuti e Psichiatri che
            rende il tuo lavoro più efficace!
          </p>
          <div class="google-buttons-container" [@fadeInUp]="'button'">
            <button class="google-btn signup" (click)="signUpWithGoogle()">
              <img
                src="assets/imgs/google-logo.png"
                alt="Google Logo"
                class="google-icon"
              />
              <span>Iscriviti con Google</span>
            </button>
            <button class="google-btn" (click)="oauthSignIn()">
              <img
                src="assets/imgs/google-logo.png"
                alt="Google Logo"
                class="google-icon"
              />
              <span>Accedi con Google</span>
            </button>
          </div>
        </div>
        <div class="privacy-link" [@fadeInUp]="'privacy'">
          <span (click)="navigateToPrivacyPage()"
            >Informativa della privacy</span
          >
        </div>
        <div
          class="privacy-link"
          style="margin-top: 0.5rem"
          [@fadeInUp]="'privacy'"
        >
          <span (click)="navigateToTermsOfServicePage()"
            >Termini di servizio</span
          >
        </div>
      </section>
      @if (!showLoader) {
        <section class="right-side" [@fadeInRight]>
          <div class="features-grid">
            <div class="feature-card">
              <div class="icon">📅</div>
              <h3>Calendario Intelligente</h3>
              <p>Gestisci appuntamenti con integrazione Google Calendar</p>
            </div>
            <div class="feature-card">
              <div class="icon">👥</div>
              <h3>Gestione Pazienti</h3>
              <p>Storico e dati sempre a portata di mano</p>
            </div>
            <div class="feature-card">
              <div class="icon">✨</div>
              <h3>AI Avanzata</h3>
              <p>
                Trascrizione e analisi dei colloqui con intelligenza artificiale
              </p>
            </div>
            <div class="feature-card">
              <div class="icon">📄</div>
              <h3>Fatturazione</h3>
              <p>Genera e invia fatture elettroniche in modo automatico</p>
            </div>
          </div>
        </section>
      }
      @if (showLoader) {
        <section class="right-side">
          <app-loader [size]="'big'"></app-loader>
        </section>
      }
    </div>
  }

  @if (isLoading) {
    <app-loader
      [size]="'very-big'"
      style="display: flex; justify-content: center; padding-top: 5rem"
    ></app-loader>
  }
</main>
